export default __webpack_public_path__ + "static/media/WM0360.34I-43122_-25782_0.83f72c37.jpg";